import { render, staticRenderFns } from "./ShineSide.vue?vue&type=template&id=4d2f8fb7&"
import script from "./ShineSide.vue?vue&type=script&lang=js&"
export * from "./ShineSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports